<template>
  <v-icon>
    {{ svgPath }}
  </v-icon>
</template>

<script>
import { mdiChevronUp } from "@mdi/js";
export default {
  name: "MdiChevronUp",
  data() {
    return {
      svgPath: mdiChevronUp,
    };
  },
};
</script>
